import {Component, OnInit} from '@angular/core';
import {WorkingObjectNamespace} from '@namespaces/working-object.namespace';
import {ActivatedRoute, Router} from '@angular/router';
import {WorkingObjectsApiService} from '@api/working-objects.api.service';
import {UserNamespace} from '@namespaces/user.namespace';
import {EventsService} from '@services/events.service';
import {RoutesStorage} from '@helpers/routes.helper';
import {NotyMessagesEnum} from '@helpers/noty-messages.enum';

@Component({
    selector: 'app-objects-view',
    templateUrl: 'object-view.component.html'
})

export class ObjectViewComponent implements OnInit {
    obj: WorkingObjectNamespace.Interface;
    requirements: string[] = [];

    public listUrl = RoutesStorage.WorkingObject.list;
    public editUrl: string;

    public permissions = UserNamespace.Permission;

    constructor(
        private route: ActivatedRoute,
        private router: Router,
        private api: WorkingObjectsApiService,
        private events: EventsService,
    ) {
    }

    ngOnInit() {
        const data = this.route.snapshot.data.data;

        if (!data) {
            return;
        }

        this.obj = data;
        this.requirements = this.obj.requirements.filter(item => item.checked).map(item => item.name);

        this.editUrl = RoutesStorage.WorkingObject.edit(this.obj.id);
    }

    remove() {
        this.events.showConfirm({
            title: 'Вы уверены, что хотите удалить объект?',
            confirmButtonTitle: 'Удалить',
        }).subscribe(() => {
            this.api.delete({
                id: this.obj.id
            }).toPromise().then(() => {

                this.events.showNoty({
                    type: 'success',
                    content: NotyMessagesEnum.workingObjectRemovedMessage
                });

                /**
                 * Переходим на список объектов
                 */
                this.router.navigate([this.listUrl]);
            }, () => {
                this.events.showNoty({
                    type: 'error',
                    content: NotyMessagesEnum.workingObjectRemovedFailMessage
                });
            });
        }, () => {});
    }
}
